<div>
    <sync-dialog 
    [config]="
    {
      title: !isValidPassword ? 'Enter your password' : 'Email-based password recovery', 
      isClosable: false, 
      actionButton: !isValidPassword ? 'Continue' : 'Save', 
      cancelButton: 'Cancel',
      onActionClick:  !isValidPassword ? checkPassword : savePasswordRecovery,
      onCancelClick: closePasswordRecoveryDialog,
    }"
    [open]="showPasswordRecoveryDialog" 
    [isFullScreen]="false"
    [onClose]="closePasswordRecoveryDialog">
        <div class="pw-recovery-container" [ngClass]="{'pw-block': !isValidPassword}">
            <app-error *ngIf="errcode" [errcode]="errcode"></app-error>
            <div class="body-2">
               {{ !isValidPassword ? 'For your security, please enter your password to verify your identity before changing this setting.'
               : 'Enabling email-based password recovery allows you to reset a forgotten password via email and ensures you cannot get locked out of your Sync account. When this feature is enabled or used, Sync will gain temporary access to your encryption keys.' }}
            </div>
            <sync-text-field *ngIf="!isValidPassword" [inputType]="'password'" [label]="'Password'" [inputChange]="getPassword" [errorMessage]="incorrectPassError"></sync-text-field>

            <div class="pw-recovery-block" *ngIf="isValidPassword">
                <sync-switch 
                    [size]="'large'"
                    [label]="'Enable email-based password recovery'" 
                    [labelPosition]="'before'"
                    [checked]="user.is_resetpassword !== 0"
                    [onChange]="togglePasswordRecovery"
                ></sync-switch>
            </div> 
         </div>
        
    </sync-dialog>
  </div>